import { doctorPhotoUrl } from "./doctorConstants";
import aa from "../AdminPortal/adminApp.module.css";
import { Avatar } from "../../ui";

export default function TrainerProfileHero({
  doctor,
  onOpenCalendar,
  onOpenSchedule,
  onOpenActions,
}) {
  const isActive = doctor?.is_active !== false;
  const statusLabel = isActive ? "Активен" : "Неактивен";

  const groups = doctor?.groups || [];
  const directions = doctor?.directions || [];
  const branches = (doctor?.branches || []).filter((b) => b.assigned !== false);

  const tags = [
    ...directions.map((d) => ({ key: `dir-${d.id}`, label: d.name, tone: "accent" })),
    ...groups.map((g) => ({ key: `grp-${g.id}`, label: g.name, tone: "muted" })),
    ...branches.map((b) => ({ key: `br-${b.id}`, label: b.name, tone: "muted" })),
  ];

  const subtitle = [
    doctor?.specialization,
    doctor?.experience_years != null ? `Стаж ${doctor.experience_years} лет` : null,
    doctor?.rating_avg != null
      ? `★ ${Number(doctor.rating_avg).toFixed(1)}`
      : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <header className={aa.trainerHero}>
      <div className={aa.trainerHeroCard}>
        <div className={aa.trainerHeroTop}>
          <div className={aa.trainerHeroAvatarRing}>
            <Avatar
              name={doctor?.full_name}
              src={doctorPhotoUrl(doctor?.photo_url)}
              size="lg"
            />
          </div>
          <span
            className={`${aa.trainerHeroStatus} ${
              isActive ? aa.trainerHeroStatusOn : aa.trainerHeroStatusOff
            }`}
          >
            {statusLabel}
          </span>
        </div>

        {doctor?.email ? (
          <a href={`mailto:${doctor.email}`} className={aa.trainerHeroEmail}>
            {doctor.email}
          </a>
        ) : null}

        {subtitle ? <p className={aa.trainerHeroSubline}>{subtitle}</p> : null}

        {tags.length > 0 ? (
          <div className={aa.trainerHeroTags}>
            {tags.slice(0, 8).map((t) => (
              <span
                key={t.key}
                className={`${aa.clientHeroTag} ${aa[`clientHeroTag_${t.tone}`] || ""}`}
              >
                {t.label}
              </span>
            ))}
          </div>
        ) : null}

        <div className={aa.trainerActionRow}>
          <button
            type="button"
            className={aa.trainerQuickActionPrimary}
            onClick={onOpenCalendar}
          >
            Календарь
          </button>
          <button
            type="button"
            className={aa.trainerQuickActionGhost}
            onClick={onOpenSchedule}
          >
            Расписание
          </button>
          <button
            type="button"
            className={aa.trainerMoreBtn}
            onClick={onOpenActions}
            aria-label="Дополнительные действия"
          >
            ⋯
          </button>
        </div>
      </div>
    </header>
  );
}
